exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".main-login[data-v-2bc43faf]{width:100%;max-width:400px;margin:0 auto}@media(max-width: 767px){.main-login[data-v-2bc43faf]{max-width:100%}}", "", {"version":3,"sources":["/home/webuser/miles/releases/159/spa/src/pages/auth/login/Login.scss"],"names":[],"mappings":"AAAA,6BACE,WACA,gBACA,aAAA,CAEA,yBALF,6BAMI,cAAA,CAAA,CAAA","file":"Login.scss?vue&type=style&index=0&id=2bc43faf&prod&lang=scss&scoped=true&","sourcesContent":[".main-login {\n  width: 100%;\n  max-width: 400px;\n  margin: 0 auto;\n\n  @media (max-width: 767px) {\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);

// exports
